import { decodeClientData } from './utils/decodeUtils';

const initialCoreModel = decodeClientData(window.coreModel);

export const initialState = {
    core: Object.assign({}, initialCoreModel, window.akamai, window.personalization, {
        pageType: 'content'
    })
};
